import { ReactElement } from 'react';
import SecurityVerificationForm from './components/SecurityVerificationForm';
import { HeadTag } from 'shared/components';

const SecurityVerificationPage = (): ReactElement => (
    <>
        <HeadTag title="Security Verification" />
        <SecurityVerificationForm />
    </>
);

export default SecurityVerificationPage;
